import gql from "graphql-tag";

export const getInvite = gql`
  query GetInvite($input: GetInviteInput!) {
    invite(input: $input) {
      invite {
        projectName
        author
        code
      }
    }
  }
`;

export const getInviteOptions = {
  name: "getInvite",
};
